import React from "react";
import { FormattedMessage } from "react-intl";

export const I18N = ({ ...innerProps }) => <FormattedMessage {...innerProps} />;
